import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import Photo from "@/components/site/Photo";

// Closing visual band — light direction: copy panel beside a full-height photo,
// no dark overlay. Text never sits on top of imagery.
export const ClosingCta = ({ photo, title, body, cta, tone = "teal", testid = "closing-cta" }) => {
  const btn =
    tone === "cobalt"
      ? "bg-cobalt focus-visible:ring-cobalt"
      : tone === "orange"
        ? "bg-orange focus-visible:ring-orange"
        : "bg-teal focus-visible:ring-teal";
  return (
    <section className="container-x section-space">
      <Reveal>
        <div
          className="grid overflow-hidden rounded-3xl border border-border bg-white shadow-soft md:grid-cols-2"
          data-testid={testid}
        >
          <div className="flex flex-col justify-center p-10 md:p-14">
            <h2 className="font-heading text-3xl font-bold tracking-tight text-navy md:text-4xl">{title}</h2>
            {body && <p className="mt-4 text-bodygrey">{body}</p>}
            {cta && (
              <div className="mt-8">
                <Link
                  to={cta.to}
                  data-testid={`${testid}-btn`}
                  className={`inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-semibold text-white shadow-soft transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${btn}`}
                >
                  {cta.label} <ArrowRight size={18} />
                </Link>
              </div>
            )}
          </div>
          <Photo
            slug={photo}
            ratio="aspect-[4/3] md:aspect-auto md:h-full"
            rounded="rounded-none"
            className="min-h-[220px]"
            data-testid={`${testid}-photo`}
          />
        </div>
      </Reveal>
    </section>
  );
};

export default ClosingCta;

